import React from 'react';
import style from './style.module.scss';
import Fade from '@mui/material/Fade';
import clsx from 'clsx';
import he from "he";

const CategoryBubble = ({ applyFilter, category, show = true, selected = false }) => (
  <Fade in={show} appear={false} timeout={800}>
    <div className={clsx(style.category, selected && style.selected)} onClick={() => { applyFilter(category.id) }}>
      <div className={style.imgContainer}>
        {category?.image?.url && <img className={style.image} src={category.image.url} alt={category.image.alt || category.image.title} loading="lazy" />}
      </div>

      <div className={style.description}>
        <span>{he.decode(category.name)}</span>
      </div>
    </div>
  </Fade>
);

export default CategoryBubble;
